import Create from './create/CreateThread';
import Individual from './individual/Thread';
import List from './list/Threads'

export default { Individual, Create, List };
